import template from './toggle-button.html';

const DIRECTIVE_NAME = ToggleButton.DIRECTIVE_NAME = 'ktToggleButton';
export default function ToggleButton() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: ToggleButtonController,
        controllerAs: '$ctrl',
        scope: {
            label: `@${DIRECTIVE_NAME}Label`,
            isTurnedOn: `=${DIRECTIVE_NAME}IsTurnedOn`,
            onChange: `&${DIRECTIVE_NAME}OnChange`,
        },
    };
}

export function ToggleButtonController() {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        toggle,
    });

    function toggle() {
        vm.isTurnedOn = !vm.isTurnedOn;

        if (vm.onChange) {
            vm.onChange({value: vm.isTurnedOn});
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/toggle-button/toggle-button-component.js